module.exports = __webpack_public_path__ + "img/logo-ligong.b3a4bea7.svg";